import React from "react";
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
import {Router, Route, Switch} from "react-router-dom";
import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import {Provider} from 'react-redux';
import rootReducer from './rootReducer';
import setAuthorizationHeader from "./utils/setAuthorizationHeader";

import indexRoutes from "routes/index.jsx";

import "assets/scss/material-dashboard-pro-react.css";

if (localStorage.authToken) {
    setAuthorizationHeader(localStorage.authToken);
}

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk))
);
/* eslint-enable */

const hist = createBrowserHistory();

ReactDOM.render(
    <Router history={hist}>
        <Provider store={store}>
            <Switch>
                {indexRoutes.map((prop, key) => {
                    return <Route path={prop.path} component={prop.component} key={key}/>;
                })}
            </Switch>
        </Provider>
    </Router>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js